import {
  Box,
  makeStyles,
  Theme,
  AppBar,
  Toolbar,
  Typography
} from '@material-ui/core';
import { useObserver } from 'mobx-react-lite';
import React, { FC, Fragment } from 'react';
import { isNullOrUndefined } from 'util';
import ViewStateContainer from '../Core/ViewStateContainer/ViewStateContainer';
import { LayoutVariant } from '../Core/CommonTypes';
import { useShop } from '../../stores/ShopStore';
import ShopOrder from './ShopOrder';
import CartButton from '../OrderingPage/CartButton/CartButton';

const useStyles = makeStyles((theme: Theme) => {
  return {
    appBar: {
      backgroundColor: theme.palette.common.black
    },
    mainContent: {
      overflowY: 'auto',
      overflowX: 'hidden',
      height: '100%',
      backgroundColor: theme.palette.common.black
    },
    mobileMainContent: {
      overflowY: 'auto',
      overflowX: 'hidden',
      height: '100%',
      backgroundColor: theme.palette.common.black
    },
    balanceMobile: {
      marginLeft: theme.spacing(3)
    }
  };
});

interface ShopOrderingPageProps {
  variant?: LayoutVariant;
  onSubmit?: () => void;
  showOrderDetail?: boolean;
  setShowOrderDetail?: (show: boolean) => void;
}

const ShopOrderingPage: FC<ShopOrderingPageProps> = ({
  variant,
  onSubmit,
  showOrderDetail,
  setShowOrderDetail
}: ShopOrderingPageProps) => {
  const shopStore = useShop();
  const classes = useStyles();

  const setShowOrderDetailDialog = (show: boolean) => {
    if (!isNullOrUndefined(setShowOrderDetail)) {
      setShowOrderDetail(show);
    }
  };

  return useObserver(() => (
    <Fragment>
      <AppBar key="appBar" position="sticky" className={classes.appBar}>
        <Toolbar>
          {variant === LayoutVariant.mobile && (
            <CartButton
              amount={shopStore.order.total}
              onClick={() => setShowOrderDetailDialog(true)}
            />
          )}
          <Typography
            className={
              variant === LayoutVariant.mobile ? classes.balanceMobile : ''
            }
          >
            K-Reward Point Balance: {shopStore.shopInfo.storeBalance}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        key="content"
        className={
          variant === LayoutVariant.mobile
            ? classes.mobileMainContent
            : classes.mainContent
        }
      >
        <ViewStateContainer
          key="content"
          state={shopStore.viewState}
          onReload={() => shopStore.reload()}
        >
          <ShopOrder
            shopStore={shopStore}
            showOrderDetailDialog={showOrderDetail || false}
            onClose={() => {
              setShowOrderDetailDialog(false);
            }}
            onSubmit={onSubmit}
            variant={variant}
          />
        </ViewStateContainer>
      </Box>
    </Fragment>
  ));
};

export default ShopOrderingPage;
